export const splitByDecimal = (x: number = 0, delimiter: string = ',') => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
};
